import { useLocation, useHistory } from "react-router-dom";
import VeloAPIService from "../Services/VeloAPIService";
import TransactorService from "../Services/TransactorService";
import { useState } from "react";
export const SOBQueryParamHandler = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const sobFromCache = sessionStorage.getItem("sourceOfBusinessId");
  const checkedForOffer = sessionStorage.getItem("checkedForOffer");
  const callCentreUserID = sessionStorage.getItem("CallCentreUserID");
  const history = useHistory();
  const [refresh, setRefresh] = useState(false);

  if (callCentreUserID == null && query.get("CallCentreUserID") != null) {
    sessionStorage.setItem("CallCentreUserID", query.get("CallCentreUserID"));
  }

  if (
    window.location.pathname.toLowerCase().includes("aggregator") ||
    window.location.pathname.toLowerCase().includes("quoteretrieval")
  ) {
    return;
  }

  if (checkedForOffer === null) {
    sessionStorage.setItem("checkedForOffer", "true");
    // LoggingService.logInfo("Entered site on : " + window.location.href);
    const code = query.get("sourcebusid") ?? null;
    VeloAPIService.checkAndApplyOfferFull(code)
      .then((data) => {
        if (data?.status === 404) {
          setRefresh(false);

          TransactorService.fetchSourceOfBusinessDiscountBannerHtml(code).then(
            (data) => {
              if (
                data?.value === null ||
                data?.value?.html === null ||
                data?.value?.html === undefined ||
                data?.value?.html === ""
              ) {
                sessionStorage.removeItem("sourceOfBusinessId");
                VeloAPIService.checkAndApplyOffer().then((data) => {
                  if (data?.status === 404) {
                    setRefresh(false);

                    sessionStorage.setItem("FoundOffer", "false");
                  } else {
                    setRefresh(true);
                    sessionStorage.setItem("checkedForOffer", "true");
                    sessionStorage.setItem("OfferActive", "true");
                    sessionStorage.setItem("OfferName", data.name);
                    sessionStorage.setItem("OfferRules", data.offerRules);
                    sessionStorage.setItem(
                      "sourceOfBusinessId",
                      data.defaultCode
                    );
                    sessionStorage.setItem("offerFooterText", data.footerText);
                    sessionStorage.setItem(
                      "jouneryHeaderText",
                      data.jouneryHeaderText
                    );
                    sessionStorage.setItem("refreshOffer", true);

                    sessionStorage.setItem("offerIcon", data.offerIcon);
                    if (refresh) {
                      console.error("1");
                      window.location.reload();
                    }
                  }
                });

                return;
              } else {
                setRefresh(true);
                sessionStorage.setItem("checkedForOffer", "true");
                sessionStorage.setItem(
                  "TransactorSOBBannerHTML",
                  data?.value?.html
                );
                sessionStorage.setItem("sourceOfBusinessId", code);
                sessionStorage.setItem("FoundOffer", "true");
                console.error("2");
                window.location.reload();
              }
            }
          );
        } else {
          setRefresh(true);
          sessionStorage.setItem("checkedForOffer", "true");
          sessionStorage.setItem("OfferActive", "true");
          sessionStorage.setItem("OfferName", data.name);
          sessionStorage.setItem("OfferRules", data.offerRules);
          sessionStorage.setItem("sourceOfBusinessId", data.defaultCode);
          sessionStorage.setItem("offerFooterText", data.footerText);
          sessionStorage.setItem("jouneryHeaderText", data.jouneryHeaderText);
          sessionStorage.setItem("offerIcon", data.offerIcon);
          sessionStorage.setItem("refreshOffer", true);
        }
      })
      .then(() => {
        query.delete("sourcebusid");
        history.replace({
          search: query.toString(),
        });
        if (refresh) {
          console.error("3");
          window.location.reload();
        }
      });
  } else if (
    sessionStorage.getItem("offerFooterText") &&
    sessionStorage.getItem("refreshOffer")
  ) {
    sessionStorage.removeItem("refreshOffer");
    window.location.reload();
  }
};

export default SOBQueryParamHandler;
